import React from 'react'
import { useToggle } from 'react-use'
import { BusyButton } from '@ztechapps/webui.button'
import map from 'lodash/map'
import { ShowIf } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'
import { useNotificationListContext } from './Context'

export const ReadUnreadButton = () => {
  const [isRead, setIsRead] = useToggle(false)
  const { handleUpdateMany, notificationListWithSelection, loading, notifications } = useNotificationListContext()
  const { selectedList } = notificationListWithSelection
  return (
    <ShowIf condition={!isEmpty(selectedList)}>
      <BusyButton
        icon={isRead ? 'envelope-open' : 'envelope'}
        onClick={async () => {
          await handleUpdateMany({
            filter: { _id: { $in: map(selectedList, (item) => item._id) } },
            input: { isRead: !isRead },
          })
          setIsRead()
        }}
        title={isRead ? 'Mark as Read' : 'Mark as Unread'}
        disabled={loading || notifications?.loading}
        isBusy={loading}
        busyText={''}
      />
    </ShowIf>
  )
}
